import { loadable } from '@namespace/common';

export default loadable(async () => ({
  default: (await import('./MobileAppBanner')).MobileAppBanner
}));
